export default "__VITE_ASSET__DqIUclGF__"